import React from 'react';
import $ from 'jquery';
class SideBar extends React.Component{
    componentDidMount(){
         $(document).ready(function(){
            $(this).on("click",".sidebar-toggle-box",function(){
                  
                  $("#sidebar").toggleClass("activeMenu");
                  $("#content").toggleClass("marginLeft");
            });
        });
     }
    render(){
        return(
            <div id="sidebar" className="nav-collapse">
            <div className="leftside-navigation">
              <ul className="sidebar-menu" id="nav-accordion">
               
                 
                <li>
                  <a className="active" href="/PatientHome">
                    <img alt="" src="images/dashboard.png" />
                    <span className="m_left">Patient</span>
                  </a>
                </li>
                <li>
                    <a href="/AdminHome">
                      <img alt="" src="images/dashboard.png" />
                      <span className="m_left">Admin</span>
                    </a>
                  </li>
                <li>
                  <a href="/EmployeHome">
                    <img alt="" src="images/dashboard.png" />
                    <span className="m_left">Employee</span>
                  </a>
                </li>
                <li>
                  <a href="/FacilityHome">
                    <img alt="" src="images/dashboard.png" />
                    <span>Facility</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )
    }
}

export default SideBar